








import autosize from 'autosize';
import { IField } from './constants';

export default {
  props: {
    value: String,
  },
  mounted() {
    autosize(this.$el);
  },
} as IField;
